import React from "react";

import { DefaultTooltip } from "../../Generic/Tooltip";
import { ContainerTooltip, TextInfo } from "./style";

export enum TooltipPlacements {
  BOTTOM = "bottom",
  LEFT = "left",
  RIGHT = "right",
  TOP = "top",
  BOTTOM_END = "bottom-end",
  BOTTOM_START = "bottom-start",
  LEFT_END = "left-end",
  LEFT_START = "left-start",
  RIGHT_END = "right-end",
  RIGHT_START = "right-start",
  TOP_END = "top-end",
  TOP_START = "top-start",
}

interface Props {
  title: string;
  placement?: TooltipPlacements;
  children: React.ReactElement<any, any>;
}

export const ToolTipInfo = ({ title, placement, children }: Props) => {
  const contentTooltip = (text: string) => {
    return (
      <ContainerTooltip container direction="row">
        <TextInfo item xs>
          {text}
        </TextInfo>
      </ContainerTooltip>
    );
  };

  return (
    <DefaultTooltip title={contentTooltip(title)} placement={placement}>
      {children}
    </DefaultTooltip>
  );
};
